import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";


@Component({
  selector: 'page-demo-pagination',
  templateUrl: 'demo-pagination.html',
})
export class DemoPaginationPage {
  items = [];
  page=1;
  EnqData=[];
  EnqData1:any;



  constructor(public navCtrl: NavController,
              public service: ServiceProvider,public navParams: NavParams) {
    // for (let i = 0; i < 30; i++) {
    //   this.items.push( this.items.length );
    // }

    this.loadValues(this.page);

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DemoPaginationPage');
  }

  loadValues(page){

    this.service.httpcall('web_service/pagination?page='+page).subscribe(data => {

      console.log(data);
      // this.EnqData=data;

       // for (let i = 0; i < data.length; i++) {
       //    this.EnqData.push( data[i] );
       //  }
       //
       //  console.log("push",this.EnqData);


    })
  }

  doInfinite(infiniteScroll) {
    console.log('Begin async operation');

    setTimeout(() => {
      // for (let i = 0; i < 30; i++) {
      //   this.items.push( this.items.length );
      // }
      this.page=this.page + 1;
      console.log("page number ", this.page);
      this.loadValues(this.page);

      console.log('Async operation has ended');
      infiniteScroll.complete();
    }, 500);
  }

}



// WEBPACK FOOTER //
// ./src/pages/demo-pagination/demo-pagination.ts